export const initialEditState = {
  ruleName: "",
  frequency: "TWO_WEEKS",
  filters: [],
  notificationRecipient: "AUTHOR",
};

const defaults = {
  initialEditState: {
    __typename: "InitialState",
    ...initialEditState,
  },
  dirtyState: {
    __typename: "DirtyState",
    ...initialEditState,
  },
  wizard: {
    __typename: "Wizard",
    currentStep: "frequency",
    showValidation: false,
  },
  articleMatchesPage: 1,
  showLoadingOverlay: false,
  notifications: [],
};

export default defaults;



// WEBPACK FOOTER //
// ./src/state/defaults.js